import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MapPin from './icon-map-pin.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MapPin {...validProps} />;
}
SvgComponent.iconName = 'mapPin';

/**
 * @deprecated This is a legacy icon
 */
export const MapPinIcon = svgIconWrapper(SvgComponent);
